import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions, Response} from '@angular/http';

import {Job} from './jobs';

@Injectable()
export class JobService {

  constructor(private http: Http) {

  }

  getAll(page: number = 1, sort: string = '') {
    let currentfilter = JSON.parse(localStorage.getItem('filter'));
    if(!currentfilter) {
      currentfilter = {};
    }

    const params = new URLSearchParams();
    params.set('page',  page+'');
    params.set('sorts', sort);
    for (let key in currentfilter) {
      if(currentfilter[key]) {
        params.set('filter[' + key + ']', currentfilter[key])
      }
    }
    return this.http.get('jobs?' + params.toString()).map((response: Response) => response.json());
  }

  getById(_id: string) {
    return this.http.get('jobs/' + _id).map((response: Response) => response.json());
  }
  getTrashedById(_id: string) {
    return this.http.get('jobs/trashed/' + _id).map((response: Response) => response.json());
  }
  restoreTrashedById(_id: string) {
    return this.http.put('jobs/trashed/' + _id,{}).map((response: Response) => response.json());
  }

  create(job: Job) {
    return this.http.post('jobs', job).map((response: Response) => response.json());
  }

  update(job: Job) {
    return this.http.put('jobs/' + job.id, job).map((response: Response) => response.json());
  }

  delete(_id: string) {
    return this.http.delete('jobs/' + _id);
  }
}



// WEBPACK FOOTER //
// ./src/app/views/setting/jobs/jobs.service.ts